import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, NavigationExtras, Router} from '@angular/router';
import {HssResponse} from '../../../../services/rest-api/HssResponse';
import {HssErrorResponse} from '../../../../services/rest-api/HssErrorResponse';
import {InfoApiService} from '../../../../services/rest-api/info.api.service';
import {SeoService} from '../../../../services/seo/seo.service';

@Component({
  selector: 'app-notice-vacancies',
  templateUrl: './allother.component.html',
  styleUrls: ['./allother.component.scss']
})
export class AllotherComponent implements OnInit {

  allData: any[] = [];
  selectedType: number = 0;
  infoTitle: string = "";
  showDeptMenu = false;

  constructor(private _info: InfoApiService,
              private _actRoute: ActivatedRoute,
              private router: Router,
              private seo: SeoService) {

    this._actRoute.paramMap.subscribe(params => {
      this.ngOnInit();
    });

  }

  ngOnInit(): void {

    this.selectedType = this._actRoute.snapshot.params.infoId;
    const deptId = this._actRoute.snapshot.params.deptId;

    if(this.selectedType == 3){
      this.infoTitle = "Student Notices";
    } else if(this.selectedType == 4){
      this.infoTitle = "Vacancies";
    }

    this.seo.setMeta(this.infoTitle,
      this.infoTitle)

    this._actRoute.paramMap.subscribe(params => {
      if(deptId != undefined){
        this.getAllArchiveDataByDept(deptId, this.selectedType);
        this.showDeptMenu=true;
      } else {
        this.getAllArchiveData(this.selectedType);
        this.showDeptMenu=false;
      }
    });
  }

  navigatePage(current: string, param?: number) {
    if (current === 'info') {
      const navigationExtras: NavigationExtras = {
        queryParams: {
          event: JSON.stringify(param)
        }
      };
      this.router.navigate(['/info/'],navigationExtras);
    }
  }

  // Get news  data - ID 1
  getAllArchiveData(typeId: number){
    this._info.getActiveArchiveInfo(typeId).subscribe (
      (response: HssResponse<any>) => {
        this.allData = response.body;
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

  getAllArchiveDataByDept(deptId: number, typeId: number){
    this._info.getActiveArchiveInfoByDept(deptId, typeId).subscribe (
      (response: HssResponse<any>) => {
        this.allData = response.body;
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }
}
